export default "__VITE_ASSET__Di3MSQzn__"